"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var verificationVerify = function (subdomain, code) {
    if (subdomain === void 0) { subdomain = ''; }
    if (code === void 0) { code = ''; }
    return (0, service_1.getService)()
        .post("/customers/subdomain/".concat(subdomain, "/user_verification/verify"), {
        code: code,
    })
        .then(function (_a) {
        var data = _a.data;
        return data;
    })
        .catch(function (_a) {
        var response = _a.response;
        return Promise.reject(response);
    });
};
exports.default = verificationVerify;
